import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 lg:py-28 bg-brown-400">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold text-white mb-6">
          あなたの想いを、ジュエリーに
        </h2>
        <p className="text-lg md:text-xl text-white/90 leading-relaxed mb-12 font-serif">
          まずはお気軽にご相談ください。<br className="md:hidden" />
          岡山市のアトリエでお待ちしております。
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:086-012-3456"
            className="w-full sm:w-auto flex items-center justify-center gap-3 px-8 py-4 bg-white text-brown-600 rounded-lg hover:bg-cream-100 transition-all font-serif text-lg shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-xl"></i>
            <span>電話で相談する 086-012-3456</span>
          </a>
          <Link
            to="/contact"
            className="w-full sm:w-auto px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white hover:text-brown-600 transition-all font-serif text-lg whitespace-nowrap cursor-pointer"
          >
            お問い合わせフォーム
          </Link>
        </div>
      </div>
    </section>
  );
}